// removed by extract-text-webpack-plugin
module.exports = {"large":"_1uhucju-sm-KA6JMeZffTK","item":"rU7xoHMm4wO28PSG8PmxO","medium":"_30fHNgR_jNtImNGxqJuTik","onWhiteBackground":"_2AxPgpjWyvifK4oxWVey8a","active":"_2JBN_wYu9gDuQ-J2fiUQDw","disabled":"_26i41AK1un4TxiJ2hqDt6p","onGrayBackground":"iaTK67grVuZ8GbhMY_3rF","onDarkBackground":"_3DJsw2Ej-7k28VWhfC_Xpu","itemContainer":"_2PHdkSOSuRi0veiDuRqeD2","divider":"_1suXytcqdY83EDNz-hVPY0","button":"_1lWkn1RtOHhbmxWGc7Ss-A","link":"_1GJUNDjkb8oBN8tAACxNof","breadcrumbs":"_1fC0B2Ro_oaR5ZCwL1Nylq"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Breadcrumbs/Breadcrumbs.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Breadcrumbs/Breadcrumbs.scss
// module chunks = 0